import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-top-navigation-item-label',
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuTopGlobalNavigationItemLabelComponent {
}
